import { Component, OnInit, ChangeDetectionStrategy, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { functionApps } from '../../../interfaces/functionApps.interface';
import { Link } from '../../../interfaces/link.interface';
import { FunctionAppsLinkService, functionAppsLinkCreateDto } from '../../../services/function-apps-link.service';
import { DxSelectBoxModule, DxTextBoxModule } from 'devextreme-angular';

@Component({
	selector: 'detailed-grid-form',
	templateUrl: './detailed-grid-form.component.html',
	styleUrls: ['./detailed-grid-form.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [DxSelectBoxModule, DxTextBoxModule, ReactiveFormsModule]
})
export class DetailedGridFormComponent implements OnInit {
	@Input() formGroup: FormGroup;
	@Input() dataSource: functionApps[];
	@Input() appName: string;
	@Input() link: Link;
	@Input() selectedFunctionAppItemId: number | null;

	/**
	 *
	 */
	constructor(private functionAppsLinkService: FunctionAppsLinkService) {}

	ngOnInit() {}

	getSelectedItemName() {
		return this.dataSource.find(item => item.id == this.selectedFunctionAppItemId)?.description;
	}

	getFunctionAppLinkConfig(): number | null {
		return this.selectedFunctionAppItemId;
	}
}
